import { Logout as LogoutIcon, Settings } from '@mui/icons-material'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Paper from '@mui/material/Paper'
import { Box } from '@mui/system'
import IconsList from 'common/constants/icons_map'
import { getMenuParams } from 'common/libs/menus'
import { selectMenus } from 'features/portal/menusSlice'
import i18n from 'lang/idiomas'
import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import ThemeManager from 'theming/ThemeManager'
import UserImage from '../../../components/UserImage'
import DropDownButton from './DropDownButton'
import IconMenuButton from './IconMenuButton'

const MenuDrawerDefault = ({
  expanded,
  DRAWER_WIDTH,
  ALLWAYS_EXPANDED,
  mobileOpen,
  open,
  handleClick,
}) => {
  const menus = useSelector(selectMenus)

  const themeManager = new ThemeManager()

  const apply = themeManager.options.apply ?? false

  return (
    <Box
      sx={{
        height: '100dvh',
        backgroundColor: {
          xs: 'menu.background',
          md: 'transparent',
        },
        maxWidth: '352px',
        p: {
          xs: 0,
          md: !ALLWAYS_EXPANDED || mobileOpen ? 0 : apply ? 0 : 1,
        },
        position: 'initial',
      }}
    >
      <UserImage
        expanded={ALLWAYS_EXPANDED || expanded}
        hideText={!mobileOpen}
        boxSx={{
          transition: '.3s ease-in',
          marginX: 'initial',
          marginBottom: 2,
          display: 'block',
          width: '100%',
          mx: 'auto',
          position: 'relative',
          top: '1.4%',
          zIndex: 2,
        }}
        iconButtonSx={{
          width: '100px',
        }}
      />
      <Paper
        className="menu"
        sx={{
          transition: '.3s',
          borderRadius: 0,
          backgroundColor: 'menu.background',
          color: 'background.menuContrast',
          display: 'block',
          overflowX: 'hidden',
          mx: 1,
        }}
      >
        <List
          sx={{
            transition: '.3s',
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            '& > *': {
              flexGrow: '0 !important',
              '&:last-child': {
                marginTop: 'auto',
              },
            },
          }}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
          <div key="mdc-list-item-1">
            {menus.map((current_menu) => {
              if (current_menu.visible !== 'S') return null
              const Icono = current_menu?.icono ? IconsList[current_menu.icono] : null
              const params = getMenuParams(current_menu)

              if (current_menu.programa) {
                return (
                  <React.Fragment key={current_menu.id}>
                    <IconMenuButton
                      key={`imb-${current_menu.id}`}
                      current_menu={current_menu}
                      menu_params={params}
                      Icono={Icono}
                      small={false}
                    />
                  </React.Fragment>
                )
              } else if (current_menu.hijos && current_menu.hijos.length > 0) {
                return (
                  <React.Fragment key={current_menu.id}>
                    <DropDownButton
                      key={`iddb-${current_menu.id}`}
                      current_menu={current_menu}
                      handleClick={handleClick}
                      Icono={Icono}
                      open={open}
                      small={false}
                    />
                  </React.Fragment>
                )
              }
              return null
            })}
          </div>
          <div key="mdc-list-item-2">
            <ListItemButton
              sx={{ p: '4px', pl: 2, pr: 1 }}
              id={99999}
              key={99999}
              component={Link}
              className="menu-list-item"
              to="/ajustes"
            >
              <ListItemIcon>
                <Settings sx={{ color: 'background.menuContrast' }} />
              </ListItemIcon>
              <ListItemText primary={i18n.t('ajustes', { defaultValue: 'Ajustes' })} />
            </ListItemButton>
            <ListItemButton
              sx={{ p: '4px', pl: 2, pr: 1 }}
              id={99998}
              key={99998}
              className="menu-list-item"
              to="/logout"
            >
              <ListItemIcon>
                <LogoutIcon sx={{ color: 'background.menuContrast' }} />
              </ListItemIcon>
              <ListItemText primary={i18n.t('logout', { defaultValue: 'Logout' })} />
            </ListItemButton>
          </div>
        </List>
      </Paper>
    </Box>
  )
}

export default MenuDrawerDefault
